import styled from 'styled-components'
import { ButtonStyleType } from 'src/types/type'
import { Rop02responsiveWidth } from '.'

const JoinSubmitWrap = styled.div`
  ${Rop02responsiveWidth}
  margin: 0 auto 16px auto;
`
const CustomBtn = styled.button<ButtonStyleType>`
  cursor: pointer;
  display: block;
  border: none;
  outline: none;
  width: ${(props) => (props.width ? props.width : '100%')};
  margin: 0 0 8px 0;
  padding: 0px 16px;
  background-color: ${(props) => props.backgroundColor};
  font-size: ${(props) => props.fontSize};
  fontfamily: ${(props) => props.fontFamily};
  color: ${(props) => props.fontColor ?? '#fff'};
  font-weight: ${(props) => props.fontWeight ?? 0};
  letter-spacing: ${(props) => props.letterSpacing};
  height: ${(props) => (props.height ? props.height : '48px')};
  border-radius: 12px;

  -webkit-tap-highlight-color: transparent;
  
  > span,
  > a {
    text-align: center;
    color: ${(props) => (props.color ? props.color : '#FFF')};
    line-height: ${(props) => (props.height ? props.height : '18px')};
    font-family: ${(props) => (props.fontFamily ? props.fontFamily : 'Noto Sans KR')};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '12px')};
  }

  &:active {
    background-color: #D13B3B;
  }
  &.btn_cancel:active {
    background-color: #F5F5F5;
  }
`

const NoticeWrap = styled.div`
  ${Rop02responsiveWidth}

  display: flex;
  margin: 0 auto 16px auto;
  height: 62px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`

const NoticeFeeText = styled.p<{ fontColor: string; fontSize: string; cashSpace: string }>`
  margin: 0 auto;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${(props) => props.fontColor};
  font-family: 'Noto Sans KR';
  font-size: ${(props) => (props.fontSize ? props.fontSize : '12.5px')};
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: ${(props) => (props.cashSpace ? props.cashSpace : '-1.23px')};
`

export { JoinSubmitWrap, CustomBtn, NoticeFeeText, NoticeWrap }
